import { jsx as t } from "react/jsx-runtime";
import { Skeleton as r } from "@mui/joy";
const i = ({ width: i2 = "102px", sx: e, ...o }) => t(r, { variant: "text", level: "title-sm", sx: { width: i2, borderRadius: "20px", ...e }, ...o });
export {
  i as TextSkeleton
};
//# sourceMappingURL=TextSkeleton.js.map
